import { render, staticRenderFns } from "./DocumentosObrigatorios.vue?vue&type=template&id=3341cb74&scoped=true&"
import script from "./DocumentosObrigatorios.vue?vue&type=script&lang=js&"
export * from "./DocumentosObrigatorios.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosObrigatorios.vue?vue&type=style&index=0&id=3341cb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3341cb74",
  null
  
)

export default component.exports